<template>
  <v-container>
    <v-toolbar flat class="main-header mb-6">
      <v-toolbar-title class="main-header__title">
        <h1>Phases</h1>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items class="main-header__contents">
        <v-btn
          class="my-auto mx-1 radius-12"
          color="success"
          to="phases/create"
        >
          <v-icon>mdi-plus-circle</v-icon>
          <span class="mx-2">New Phase</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <hr class="mb-6" />
    <v-data-table
      :headers="headers"
      :loading="loadingDataTable"
      :items="phases"
      :mobile-breakpoint="zero"
      :items-per-page="200"
      hide-default-footer
      class="table teams"
    >
      <template v-slot:item="{ item, index }">
        <tr class="table__row">
          <td class="table__cell name text-center">
            {{ item ? item.name : "---" }}
          </td>
          <td class="table__cell name text-center">
            <read-more
              more-str="more"
              less-str="less"
              :text="item.intro || '---'"
              :max-chars="15"
              class="mb-0 major-description m-b-0"
            ></read-more>
          </td>
          <td class="table__cell name text-center">
            <read-more
              more-str="more"
              less-str="less"
              :text="item.hidden_reason || '---'"
              :max-chars="15"
              class="mb-0 major-description m-b-0"
            ></read-more>
          </td>
          <td class="table__cell text-center">
            <router-link
              :to="`phases/questions?phase=${item.id}`"
              class="hovering edit"
            >
              <v-icon small>mdi-eye</v-icon>
            </router-link>
          </td>
          <td class="table__cell text-center">
            <v-icon title="Priority" @click="prioritize(item)"
              >mdi-priority-high</v-icon
            >
          </td>
          <td class="table__cell text-center">
            <router-link
              :to="{ name: 'phasesEdit', params: { id: item.id } }"
              class="hovering mr-3 edit"
            >
              <v-icon small>mdi-pencil</v-icon><br />
              Edit
            </router-link>

            <span @click="handleDelete(item, index)" class="hovering delete">
              <v-icon small>mdi-delete</v-icon><br />
              Delete
            </span>
            <!-- <span v-else>---</span> -->
            <!-- @click="showPhases(item)" -->
            <!-- <span v-else>---</span>
             v-if="
                permissions.includes(
                  'update_api_admin-panel_cashiers_{cashier}'
                )
              " 
              v-if="
                permissions.includes(
                  'update_api_admin-panel_cashiers_{cashier}'
                )
              "
              -->
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="priority" max-width="500px">
      <PriorityDialog
        :appData="appData"
        @closePriorityDialog="closePriorityDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, ShowData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      appData: {},
      dialog: false,
      priority: false,
      loading: false,
      headers: [],
      phases: [],
      appTypePhases: [],
      loadingDataTable: false
    };
  },
  components: {
    PriorityDialog: () => import("./components/PriorityDialog")
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.createTableHeaders();
    this.indexphases();
  },
  methods: {
    indexphases() {
      this.loadingDataTable = true;
      IndexData({ reqName: `hr/phases` })
        .then(res => {
          const { data } = res.data;
          this.phases = data;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },

    // showPhases({ id }) {
    //   this.dialog = true;
    //   ShowData({
    //     reqName: `hr/application-types`,
    //     id: id
    //   })
    //     .then(res => {
    //       const { application_type } = res.data;
    //       this.appTypePhases = application_type.phases;
    //       this.appData = application_type;
    //     })
    //     .catch(() => {});
    //   IndexData({ reqName: `/hr/phases` })
    //     .then(res => {
    //       this.phases = res.data.data;
    //     })
    //     .catch(() => {})
    //     .finally(() => {});
    // },
    createTableHeaders() {
      const headersList = [
        "Name",
        "Intro",
        "Hidden Reason",
        "Questions",
        "Priority",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    closeDialog() {
      this.dialog = false;
      this.appTypePhases = [];
    },
    closePriorityDialog() {
      this.priority = false;
      this.appData = {};
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/hr/phases`,
            id: id
          })
            .then(() => {
              this.phases.splice(index, 1);
              // this.$delete(this.items, index);
            })
            .catch(() => {});
        }
      });
    },
    prioritize({ id }) {
      this.priority = true;
      ShowData({
        reqName: `hr/phases`,
        id: id
      })
        .then(res => {
          const { phase } = res.data;
          this.appData = phase;
        })
        .catch(() => {});
    }
  }
};
</script>
